import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Fa from 'react-fontawesome';
import DateTimeDisplay from '../../../../components/date-time-display';
import NumberDisplay from '../../../../components/number-display';
import HistoryLogsWrapper from '../../../../components/history-logs-wrapper';

function ForecastCloseDateRenderer(props) {
  const { value, data, node } = props;
  const isGrouped = node && node.group;
  if (value === null) {
    return null;
  }
  const comp = (<DateTimeDisplay value={value} format="MMM DD" />);
  if (isGrouped) {
    // groupping
    return comp;
  }

  let suffixComp = null;
  let suffixComp2 = null;

  if (data && data.delta_days !== 0) {
    const isNegative = data.delta_days < 0;
    const isPossitive = data.delta_days > 0;
    let labelCls = 'label-default';
    if (isNegative) {
      labelCls = 'label-danger';
    } else if (isPossitive) {
      labelCls = 'label-success';
    }
    suffixComp = (
      <span>
        &nbsp;<span className={`label ${labelCls}`}><NumberDisplay value={data.delta_days} precision={0} suffix="day" suffixIsUnit withPlus /></span>
      </span>
    );
  }
  if (data && data.has_past_close_date) {
    suffixComp2 = (<span className="text-danger">&nbsp;<Fa name="calendar-o" /></span>);
  }

  return (
    <HistoryLogsWrapper type="close_date" opportunity={data}>
      <span>{comp}{suffixComp}{suffixComp2}</span>
    </HistoryLogsWrapper>
  );
}

ForecastCloseDateRenderer.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.instanceOf(moment),
    PropTypes.string,
  ]),
  data: PropTypes.shape({
    delta_days: PropTypes.number,
    is_untracked: PropTypes.bool,
    has_past_close_date: PropTypes.bool,
  }),
  node: PropTypes.shape({
    group: PropTypes.bool,
  }),
};
ForecastCloseDateRenderer.defaultProps = {
  value: null,
  node: null,
  data: null,
};

export default ForecastCloseDateRenderer;
